import Collection from '../../collection';
import RefBooksModule from './refbooks.module';
import Stickers from '../../collection/refbooks/stickers';
import Types from '../../collection/refbooks/types';
import Field from '../../model/refbooks/field';

import Config from '../../config';

import { roleA, roleC } from '../../roles';
import { hashify } from '../../utils/arrays';
import { error } from '../../ui/messages'
import { handle } from '../../service/messages';  
import { beginLock, endLock } from '../../loader';
import { filterAvailableStickers } from '../../model/refbooks/field.utils';





const 
    OPEN_FIELD = 'field-form--popup',
    TOGGLE_BOUND_TYPES = 'field-form--toggle-bound-types',
    TOGGLE_NESTED_FIELDS = 'field-form--toggle-nested-fields',
    TOGGLE_BOUND_STICKERS = 'field-form--toggle-bound-stickers';





export default RefBooksModule.extend( {

    open({ field, original }) {
        if (!field.id && !field.get( 'cluster' ))
            if (this.state().cluster && this.state().cluster.id != -1)
                field.set( 'cluster', this.state().cluster );
            else if (~roleC.indexOf( Config.role() ))
                field.set( 'cluster', Config.cluster() );

        this.original = original;

        this.options.typesSorted = new Types();
        this.options.typesFiltered = new Types();
        this.options.typesResulted = new Types();

        return this.finalizeOpen( field );
    },

    onBind() {
        // rewrite originalModel with passed value
        this.originalModel = this.original || this.originalModel;
    },

    finalizeOpen(/* field */) {},

    start() {
        this.listenTo( this.model, 'change', 
            () => this.Buttons.render() );
        this.listenTo( this.model, 'change:format',
            () => this.model.set( 'default_value', '' ) );
        this.listenTo( this.model, 'change:is_for_all',
            () => {
                if (this.model.get( 'is_for_all' ) !== 'f')
                    this.$( '.-toggle-wrapper, .-toggle-all' ).addClass( '--invisible' );
                else
                    this.$( '.-toggle-wrapper, .-toggle-all' ).removeClass( '--invisible' );
                    
                this.Roles.render();
            } )
        this.finalizeStart( this.model );

        return this;
    },

    finalizeStart(/* field */) {},

    stop() {
        return this.stopListening( this.model ), this;
    },

    // copied from form.js
    diff(options = {}) {
        return this.model
            ? this.model.diff( this.originalModel, options )
            : [];
    },

    hasDiff(options = {}) {
        return this.diff( options ).length > 0;
    },

    events: {

        'click .-save'() {
            const { ...json } = this.model.clone().toJSON();

            const onReject = message => {
                endLock( this );
                handle( this, error( message ) );
            };

            beginLock( this );

            const { result, messages } = this.Fields.validate();
            if (!result)
                return onReject( messages[0] /* [text, field] */ );

            if (this.diff().filter( ({ attrName }) => attrName === 'bindings' )) {
                const bindings = this.model.get( 'bindings' );
                const roles = hashify( this.options.roles.map( role => role.id ) );
                json.bindings_array = bindings;
                json.bindings = {
                    add: bindings
                        .filter( binding => !binding.id )
                        .filter( binding => 
                            [undefined, true, 't'].includes( binding.on ) ||
                            [true, 't'].includes( this.model.get( 'is_for_all' ) ) ),
                    update: bindings
                        .filter( binding => binding.id )
                        .filter( binding => Field.isBindingChanged( binding, this.originalModel ) )
                        .map( ({ ...binding, rules }) => ({
                            ...binding,
                            rules: rules.map( ({ ...rule, visible_inverted_for_roles }) => ({
                                ...rule,
                                visible_inverted_for_roles: visible_inverted_for_roles
                                    .filter( id => roles[id] )
                            }) )
                        }) ),
                };
            }

            const toSave = adjustAttrsBeforeSave( 
                json,
                this.options.types, 
                this.options.stickers );

            const fieldToSend = new Field( toSave );
            if (json.format !== 'file') // no format in fieldToSend at PATCH
                fieldToSend.set( 'file_semantics', [] ),
                fieldToSend.set( 'sticker_ids', null );

            return this.options.fields.save( fieldToSend )
                    .then( attrs => new Field( attrs ) )
                    .then( 
                        (/*field*/) => this.trigger( RefBooksModule.BACK ), 
                        onReject );
        },

        'click .-close'() {
            this.trigger( RefBooksModule.BACK );
        },

    },

    [RefBooksModule.event(':bound-types:toggle')]() {
        this.trigger( TOGGLE_BOUND_TYPES,
            this.model,
            this.originalModel,
            this.state() );
    },

    [RefBooksModule.event(':nested-fields:toggle')]() {
        this.trigger( TOGGLE_NESTED_FIELDS,
            this.model,
            this.originalModel,
            this.state() );
    },

    [RefBooksModule.event(':bound-stickers:toggle')]() {
        this.trigger( TOGGLE_BOUND_STICKERS,
            this.model,
            this.originalModel,
            this.state() );
    },

    [RefBooksModule.event( 'Fields:file-semantics:toggle' )](passedSemantics) {
        const contains = this.model.get( 'file_semantics' ).includes( passedSemantics );
        const newSemantics = contains
            ? this.model.get( 'file_semantics' ).filter( ft => ft !== passedSemantics )
            : [...this.model.get( 'file_semantics' ), passedSemantics];
        this.model.set( 'file_semantics', newSemantics );
    },

    getAvailableFilteredModelIds(collection) {
        const models = collection instanceof Collection
            ? collection.models
            : collection;
    
        return models
            // ignore unavailable (disabled) checkboxes
            .filter( type => 
                // chief admin may check any MODEL
                // (local MODELS of wrong cluster do not pass filtration)
                roleA.includes( Config.role() ) ||
                // local MODELS may be checked anyway
                // (local MODELS of wrong cluster do not pass filtration)
                type.get( 'cluster' ) ||
                // local field may be joined to any MODEL
                // (local MODEL of wrong cluster do not pass filtration)
                this.model.get( 'cluster' ) )
            .map( type => type.id );
    }
    
}, {

    OPEN_FIELD,

    TOGGLE_BOUND_TYPES,

    TOGGLE_NESTED_FIELDS,

    TOGGLE_BOUND_STICKERS,

} );





function adjustAttrsBeforeSave(topLevelJson, typeCollection, stickerCollection, json) {
    json = json || topLevelJson;

    const { id, format,
        translit, order, is_required,
        default_value,
        possible_values, 
        min_length, max_length, 
        multiselect, table_id, allow_add_num,
        regexp, 
        min_count, max_count, subfields,
        min_size, max_size, auto_apply_sticker, file_semantics, sticker_ids,
        __all_stickers_available,
        ...attrs } = json;
    
    // remove fake ids
    if (id < 1000000000)
        attrs.id = id;

    // don't send "format", "translit", "order" fields to the server - those are unchangeable.
    // Don't clear "id" field: if cleared, will force
    // POST-request instead of PUT.
    if (!attrs.id)
        attrs.format = format;

    // possible_values is possible only for "list"                
    if ('list' === format)
        attrs.possible_values = possible_values;

    // min_length/max_length is possible only for "string", "text"
    if (~['string', 'text'].indexOf( format ))
        attrs.min_length = min_length,
        attrs.max_length = max_length;

    // regexp is possible only for "string", "text", "int", "float"                
    if (~['string', 'text', 'int', 'float'].indexOf( format ))
        attrs.regexp = regexp;

    if ('dataTableObjects' === format)
        attrs.multiselect = multiselect,
        attrs.allow_add_num = allow_add_num,
        attrs.table_id = table_id;

    if ('composite' === format || 'file' === format)
        attrs.min_count = min_count,
        attrs.max_count = max_count;

    if ('file' === format)
        attrs.min_size = min_size,
        attrs.max_size = max_size,
        attrs.auto_apply_sticker = auto_apply_sticker,
        attrs.file_semantics = file_semantics,
        attrs.sticker_ids = sticker_ids == null || __all_stickers_available
            ? null
            : filterStickerIds( typeCollection, stickerCollection, topLevelJson, sticker_ids );
    else
        attrs.min_size = attrs.max_size = attrs.auto_apply_sticker = attrs.file_semantics = attrs.sticker_ids =
            undefined;

    if ('composite' === format)
        // is_for_all, types, bindings, group_name are for top-level fields only
        attrs.subfields = subfields
            .sort( ({ order: a }, { order: b }) => a - b )
            .map( ({ is_for_all, news_type_ids, bindings, group_name, order, ...others }) => 
                adjustAttrsBeforeSave( 
                    topLevelJson,
                    typeCollection, stickerCollection,
                    {
                        ...others,
                        cluster: attrs.cluster // copy parent cluster
                    } ) );
    else
        // required, defaults is for non-composites only
        attrs.is_required = is_required,
        attrs.default_value = default_value;
    
    return attrs;
}

function filterStickerIds(typeCollection, stickerCollection, field, stickerIds) {
    if (stickerIds == null)
        return stickerIds;

    const ids = hashify( stickerIds );
    const stickers = new Stickers( stickerCollection
        .models
        .filter( stickerModel => ids[stickerModel.id] ) )

    return filterAvailableStickers( typeCollection, field, stickers )
        .models
        .map( sticker => sticker.id );
}








// WEBPACK FOOTER //
// ./src/js/module/refbooks/fields.form.template.js